// Same as ModelOptiosn but with string values so that can

import { ModelColor } from '../../pages/productConfiguration/state/model/modelColor';
import { ModelOptions } from '../../pages/productConfiguration/state/model/modelOptions';
import { ModelSide } from '../../pages/productConfiguration/state/model/modelSide';

export interface EditableModelOptionsPreset {
    name: string;
    width: string;
    height: string;
}

// be changed inside inputs - Mauro
export interface EditableModelOptions extends Omit<
    ModelOptions,
    | 'startWidth'
    | 'startHeight'
    | 'maxWidth'
    | 'maxHeight'
    | 'minWidth'
    | 'minHeight'
    | 'stepWidth'
    | 'stepHeight'
    | 'maxSizeForSide'
    | 'minArea'
    | 'maxArea'
    | 'startSplitColumns'
    | 'startSplitRows'
    | 'minSplitWidth'
    | 'minSplitHeight'
    | 'depth'
    | 'presets'
    | 'backgroundType'
    | 'backgroundColor'
    | 'backgroundPresetID'
    | 'backgroundImageTempUrl'
    | 'backgroundImageFileObjectID'
    | 'backgroundImageThumbnailFileObjectID'
    | 'backgroundImageUrl'
    | 'backgroundImageThumbnailUrl'
> {
    startWidth: string;
    startHeight: string;
    maxWidth: string;
    maxHeight: string;
    maxSizeForSide: string;
    minArea: string;
    maxArea: string;
    minWidth: string;
    minHeight: string;
    startSplitColumns: string;
    startSplitRows: string;
    minSplitWidth: string;
    minSplitHeight: string;
    depth: string;
    stepWidth: string;
    stepHeight: string;
    presets?: EditableModelOptionsPreset[] | null;
    backgroundType?: number | null;
    backgroundColor?: string | null;
    backgroundPresetID?: number | null;
    backgroundImageTempUrl?: string | null;
    backgroundImageFileObjectID?: number | null;
    backgroundImageThumbnailFileObjectID?: number | null;
    backgroundImageUrl?: string | null;
    backgroundImageThumbnailUrl?: string | null;
}

// Sample side when adding a new side
export const createDefaultEditableModelOptions = (modelColor: ModelColor, modelSide: ModelSide | null) => {
    const modelOptions: EditableModelOptions = {
        optionID: null,
        colorGuid: modelColor.guid,
        sideGuid: modelSide?.guid ?? null,
        isResizable: false,
        is3DAutoGenEnabled: false,
        isSplitOutput: false,
        startWidth: '10',
        minWidth: '1',
        maxWidth: '100',
        stepWidth: '1',
        startHeight: '10',
        minHeight: '1',
        maxHeight: '100',
        stepHeight: '1',
        maxSizeForSide: '10',
        minArea: '1',
        maxArea: '100',
        depth: '1',
        shape: 0, // 0 for rectangle, 1 for circle, etc.
        keepAspectRatio: false,
        lockWidth: false,
        lockHeight: false,
        showWidthSize: true,
        showHeightSize: true,
        showSplitGrid: true,
        mirrorType: 'NONE',
        edgesColor: null,
        includeBorderInPrintFiles: false,
        minSplitWidth: '1',
        minSplitHeight: '1',
        startSplitColumns: '1',
        startSplitRows: '1',
        presets: null,
        backgroundType: null,
        backgroundColor: null,
        backgroundPresetID: null,
        backgroundImageTempUrl: null,
        backgroundImageFileObjectID: null,
        backgroundImageThumbnailFileObjectID: null,
        backgroundImageUrl: null,
        backgroundImageThumbnailUrl: null
    };

    return modelOptions;
};
